<div class="grid">
  <div class="col-12 md:col-10 md:col-offset-1">
    <div class="page-header mb-6">
      <h1 class="page-header-search">
        {{ 'Search.SearchResults' | translate }}
      </h1>
      <div class="yellow-underline"></div>
    </div>

    @let state = searchState();
    @if (state.status === eActionStatus.Initial) {
      <div class="grid">
        <div class="col-12">
          <ng-container
            *ngTemplateOutlet="
              loadingTemplate;
              context: {
                config: {
                  count: 5,
                  width: '70vw',
                  height: '5rem',
                  inline: false,
                },
              }
            " />
        </div>
        <div class="col-12">
          <ng-container
            *ngTemplateOutlet="
              loadingTemplate;
              context: {
                config: {
                  count: 4,
                  width: '2rem',
                  height: '2rem',
                  inline: true,
                },
              }
            " />
        </div>
      </div>
    } @else {
      <p-table
        class="w-full"
        dataKey="id"
        [value]="results"
        [lazy]="true"
        (onLazyLoad)="loadResults($event)"
        (onPage)="onPageChange($event)"
        [paginator]="results && results.length > 0"
        [rows]="pageSize"
        [first]="first"
        [totalRecords]="totalRecords"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="pageSizeOptions"
        [loading]="state.status === eActionStatus.Pending"
        [sortField]="sortField"
        [sortOrder]="sortOption">
        <ng-template pTemplate="body" let-result>
          <tr>
            <td class="hover:bg-black-alpha-10 border-round pb-3 cursor-pointer" (click)="viewObject(result)">
              <div class="grid-coloum-field w-full flex align-items-center justify-content-between">
                <a class="mb-2 no-underline">
                  <h5 [innerHTML]="result.name | highlight: result.searchTerm"></h5>
                </a>
                <p-button
                  icon="pi pi-arrow-right bg-primary-50 text-primary border-round"
                  styleClass="border-0 focus:border-0 focus:shadow-none bg-primary-50 p-4" />
              </div>
              <div class="grid-coloum-field">
                <div class="align-items-center gap-2 mb-2"></div>
                <div
                  [innerHTML]="result.description | highlight: result.searchTerm"
                  class="align-items-center gap-2"></div>
              </div>
              <div class="grid-coloum-field">
                <div class="align-items-center gap-2 mb-2"></div>
                <div
                  [innerHTML]="result.optionGeneContent | highlight: result.searchTerm"
                  class="align-items-center gap-2"></div>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" class="font-bold border-0">
              {{ 'Search.NoResultsFound' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>

<ng-template #loadingTemplate let-config="config">
  <div [class.flex]="config.inline">
    @for (n of getNumberArray(config.count); track n) {
      <div
        class="p-2"
        [class.inline-flex]="config.inline"
        [class.w-full]="!config.inline"
        [class.flex]="!config.inline">
        <p-skeleton [width]="config.width" [height]="config.height" class="overflow-hidden" />
      </div>
    }
  </div>
</ng-template>
